export default __webpack_public_path__ + "static/193-a3e529e1e6109f06baecf0be6590ccfc.jpg";